<template>
  <page-layout title="전체 실적">
    <template v-slot:search>
      <loan-performance-total-search-bar
        @defaultDate="setDefaultDate"
        @search="getSearch"
      />
    </template>
    <template v-slot:table>
      <loan-performance-total-detail
        :data="performanceAllData"
        :loading="loading"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import LoanPerformanceTotalSearchBar
  from "@/pages/Loan/components/LoanPerformanceTotal/LoanPerformanceTotalSearchBar.vue";
import LoanPerformanceTotalDetail from "@/pages/Loan/components/LoanPerformanceTotal/LoanPerformanceTotalDetail.vue";
import {axiosInstance} from "@/util/AxiosModule";

export default {
  name: "LoanPerformanceTotal",
  components: {LoanPerformanceTotalDetail, LoanPerformanceTotalSearchBar, PageLayout},
  data() {
    return {
      defaultStartDate: "",
      defaultEndDate: "",
      performanceAllData: {},
      loading: false
    }
  },
  mounted() {
    this.getSearch({
      stDt: this.defaultStartDate.replaceAll("-", ""),
      edDt: this.defaultEndDate.replaceAll("-", "")
    });
  },
  methods: {
    async getSearch(params) {
      this.loading = true;
      try {
        const { data } = await axiosInstance.get("/admin/performance/performance-all", { params });
        this.performanceAllData = data;
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
      this.loading = false;
    },
    setDefaultDate(dates) {
      this.defaultStartDate = dates.fromDate;
      this.defaultEndDate = dates.toDate;
    }
  }
}
</script>